// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { previouslyPurchasedbadgeStyles } from "@vanmeter/App/Components/CustomBadges/PreviouslyPurchasedBadge";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export const twoLinesPrevPurchasedbadgeStyles = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 4px 0px;
    font-size: ${fontConfig.xxSmallSingleLine.size}px;
    font-weight: ${fontConfig.weight.regular};
    line-height: ${fontConfig.xxSmallSingleLine.lineHeight};
    b {
        margin: 0;
    }
`;

const oneLinePrevPurchasedbadgeStyles = css`
    font-size: ${fontConfig.xSmallSingleLine.size}px;
    font-weight: ${fontConfig.weight.regular};
    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
    letter-spacing: 0;
    b {
        margin-left: 4px;
    }
`;

previouslyPurchasedbadgeStyles.textBadgeCss = {
    css: css`
        ${({ displayBadgeInTwoLines }: any) =>
            displayBadgeInTwoLines ? twoLinesPrevPurchasedbadgeStyles : oneLinePrevPurchasedbadgeStyles}
    `,
};

previouslyPurchasedbadgeStyles.textBadgeWrapperCss = {
    css: css`
        box-shadow: 2px 0 0 0 inset ${color("common.ui8")};
        background-color: ${color("common.black")};
        width: 90px;
        padding: 0 4px 0 6px;

        ${({ displayBadgeInTwoLines }: any) =>
            displayBadgeInTwoLines &&
            css`
                width: 68px;
            `}
    `,
};
